import {
  ComponentProps,
  Fragment,
  forwardRef,
  ForwardRefExoticComponent,
  RefAttributes,
  FC,
  Ref,
} from "react";
import { Tab } from "@headlessui/react";
import classNames from "classnames";
import { PageLayout } from "../../PageLayout/PageLayout";
import {
  PagesCarousel,
  PagesCarouselProps,
} from "../PagesCarousel/PagesCarousel";

type NavTabType = typeof Tab & {
  CarouselPanels: (props: PagesCarouselProps) => JSX.Element;
  NavTab: ForwardRefExoticComponent<
    ComponentProps<FC> & RefAttributes<HTMLElement>
  >;
};

const NavTab = (
  props: ComponentProps<FC>,
  ref: Ref<HTMLElement> | undefined
) => (
  <Tab
    className={({ selected }) =>
      classNames("p-2 px-3 whitespace-nowrap text-base ", {
        "border-b-2 border-brand font-semibold text-brand": selected,
        "border-b border-transparent text-black font-light hover:text-brand":
          !selected,
      })
    }
    ref={ref}
    {...props}
  />
);

NavTab.displayName = "NavTab";
NavTab.NavTab = forwardRef(NavTab) as NavTabType["NavTab"];
NavTab.NavTab.displayName = "NavTab.NavTab";

NavTab.Group = Tab.Group;

type NavTabListType = typeof Tab.List;
const NavTabList: NavTabListType = (props) => (
  <nav className="overflow-y-auto w-full scroll-hidden">
    <Tab.List
      className="container flex flex-nowrap items-end mx-auto scroll-hidden"
      {...props}
    />
  </nav>
);
NavTabList.displayName = "NavTabList";
NavTab.List = NavTabList;

const NavTabPanels = (props: PagesCarouselProps) => (
  <PagesCarousel {...props}>{props.children}</PagesCarousel>
);
NavTab.CarouselPanels = NavTabPanels;

NavTab.Panels = Tab.Panels;

type NavTabPanelType = typeof Tab.Panel;
const NavTabPanel: NavTabPanelType = (props) => (
  <PageLayout>
    <Fragment {...props} />
  </PageLayout>
);
NavTabPanel.displayName = "NavTabPanel";
NavTab.Panel = NavTabPanel;

export { NavTab };
